import * as React from 'react';

import { ClassRelationshipItem } from 'src/containers/ProjectDiagram/components/classDrawer/types';
import { useGenerateNewIri } from 'src/containers/ProjectDiagram/hooks/entityDrawer/useGenerateNewIri';
import { generateModelConceptIri } from 'src/containers/ProjectDiagram/utils/generateProjectIri';
import { projectSelector } from 'src/selectors/project';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useCreateModelConceptRelationshipFromQuery = (
  existingIris?: Set<string>
) => {
  const { projectId } = useRouterParams();
  const project = useReduxSelector(projectSelector(projectId));

  const generateNewIri = useGenerateNewIri(existingIris);

  return React.useCallback(
    (query: string): ClassRelationshipItem => {
      const text = query.trim();

      if (!project) {
        return { text, value: '', isNewlyCreated: true, directions: [] };
      }
      const initialValue = generateModelConceptIri(project, text);
      const value = generateNewIri(initialValue);

      return {
        text,
        value,
        isNewlyCreated: true,
        directions: [],
      };
    },
    [project, generateNewIri]
  );
};
